import React from "react";
import makeStyles from "@material-ui/core/styles/makeStyles";
import findByString from "../../../../../Utils/Form/FormDynamic/Utils/getValueByString";
import getParamsFromString from "../../../Utils/getParamsFromString";
import TableRow from "./TableRow";

const useStyles = makeStyles(() => ({
    flexBody: {
        display: 'flex',
        flexDirection: 'column'
    },
}));
const TableBody = (props) => {
    const {
        arrayValues, arrayPath, elementPath,
        globalValues, element,
        setActiveCell, openGroupMenu, tableUID,
        onOpenContext, goBack, screenName
    } = props;
    const classes = useStyles();
    const arrayLength = arrayValues.length;
    let countHidden = 0;
    return (
        <div className={classes.flexBody}>
        {arrayValues.map((row, index) => {
            let newPath = elementPath.split('.');
            newPath[newPath.length - 1] = `${newPath[newPath.length - 1]}`;
            newPath = newPath.join('.');
            const rowPath = arrayPath ? arrayPath : element.properties.path;
            const currentRow = findByString(globalValues.param[screenName], `${rowPath}.${index}`);
            const isHiddenCond = element.properties.hideCondition ?
                getParamsFromString(element.properties.hideCondition, {row: currentRow}, screenName) : false;
            const isHidden = isHiddenCond === 'true';
            countHidden = isHidden ? countHidden + 1 : countHidden;
            return (
                <TableRow
                    key={index}
                    arrayPath={arrayPath}
                    element={{...element, properties: {...element.properties, path: newPath}}}
                    arrayLength={arrayLength}
                    setActiveCell={setActiveCell}
                    indexValue={index}
                    openGroupMenu={openGroupMenu}
                    isHidden={isHidden}
                    tableUID={tableUID}
                    visibleIndex={index - countHidden}
                    onOpenContext={onOpenContext}
                    goBack={goBack}
                />
            )
        })}
        </div>
    )
};
export default TableBody

TableBody.defaultProps = {
    elementPath: ''
};